module.exports = "https://web-assets.ifttt.com/packs/media/ifttt_next/pro-plus-upsell-story-cadf27fc.svg";